import { render, staticRenderFns } from "./ReportingIcon.vue?vue&type=template&id=6bd7f342&scoped=true"
var script = {}
import style0 from "./ReportingIcon.vue?vue&type=style&index=0&id=6bd7f342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd7f342",
  null
  
)

export default component.exports